module.exports = "https://cdn2-fs.clearscore.com/flux/images/493b11a6a4c896bc51ab072ac7d6069b.jpg";